import styled from '@emotion/styled';
import { media, Colors, helperTypographyTitle, ParagraphEmotion } from '@utex/ui-kit';

export const Title = styled('h1')`
  ${helperTypographyTitle({ size: { all: 'XXXL', mobile: 'XXL' } })};
  margin-bottom: 2rem;
  text-align: center;

  @media ${media.phonablet} {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
`;

export const Block = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 96rem;
  min-height: 42rem;
  margin: 0 auto;
  padding: 5rem;
  text-align: center;
  background-color: ${Colors.ut.bgDim};
  border-radius: 1rem;

  @media ${media.phonablet} {
    min-height: 35.4rem;
    padding: 3.3rem 1.2rem 3.3rem;
  }

  ${ParagraphEmotion} + ${ParagraphEmotion} {
    @media ${media.phonablet} {
      margin-top: 0.5rem;
    }
  }
`;

export const CompassWrapper = styled('div')`
  position: relative;
  width: 11.9rem;
  height: 14.4rem;

  @media ${media.phonablet} {
    width: 8.4rem;
    height: 10.2rem;
  }
`;

export const Compass = styled('img')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const Arrow = styled('img')`
  position: absolute;
  top: 4.7rem;
  left: 2.1rem;
  width: 8.3rem;
  height: 8.3rem;

  animation: rotate infinite 2.25s linear;

  @media ${media.phonablet} {
    top: 3.3rem;
    left: 1.5rem;
    width: 5.9rem;
    height: 5.9rem;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    44% {
      transform: rotate(10deg);
    }
    45% {
      transform: rotate(15deg);
    }
    47% {
      transform: rotate(12deg);
    }
    50% {
      transform: rotate(15deg);
    }
    60% {
      transform: rotate(-10deg);
    }
    74% {
      transform: rotate(-15deg);
    }
    85% {
      transform: rotate(15deg);
    }
    86% {
      transform: rotate(-5deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;

interface WrapperProps {
  isMainPageFooter?: boolean;
}

export const Wrapper = styled('div')<WrapperProps>`
  width: 100%;
  max-width: 128rem;
  margin: 0 auto;
  padding-left: 4rem;
  padding-right: 4rem;
  padding-bottom: ${props => props.isMainPageFooter && '4rem'};

  @media ${media.phonablet} {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 0;
  }
`;
